import { API } from '../axios-instance'
import { AppEntityTypes, WithPermissions } from '../shared/types'

export const listApps = async () => {
  return await API.get<App[]>('/apps').then(r => r.data)
}
export type App = WithPermissions<{
  __entity_type__: AppEntityTypes
}>
